// ErrorPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import './errorPage.css';  // Asegúrate de importar el archivo CSS

const ErrorPage = () => {
  return (
    <div className="error-container">
      <h1 className="error-header">¡Ups! Página no encontrada (404)</h1>
      <p className="error-paragraph">Lo sentimos, la página que buscas no existe o ha sido movida.</p>
      <Link to="/" className="error-button">Volver al inicio</Link>
    </div>
  );
};

export default ErrorPage;
